import React from 'react';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import CgmpProducts1 from '../assets/img/cgmp-Products-1.jpg';
import CgmpProducts2 from '../assets/img/cgmp-Products-2.jpg';
import CgmpProducts3 from '../assets/img/cgmp-Products-3.jpg';
import CgmpProducts4 from '../assets/img/cgmp-Products-4.jpg';

function CgmpProducts() {
    return (
        <>
            <Header1 />
            <section className='blog-wrapper news-wrapper section-padding'>
                <div className='container'>
                    <div className='row'>
                        <div className="col-md-12">
                            <div className="news-content">
                                <div className="section-heading">
                                    <p className='mb-0'><strong>cGMP</strong> Products:</p><h5 className='mb-0 pb-0'></h5><p></p>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6 col-12'>
                                        <div className="card">
                                            <img src={CgmpProducts1} className="w-100 img-responsive" alt="" />
                                            <div className="card-body">
                                                <ul>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human EGF 100 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human FGF-2 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human Flt3-Ligand 100 μg </li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human GM-CSF 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human IL-1β 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human IL-2 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human IL-2 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human IL-4 25 μg</li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <div className="card">
                                            <img src={CgmpProducts2} className="w-100 img-responsive" alt="" />
                                            <div className="card-body">
                                                <ul>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human IL-6 10 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human IL-7 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human IL-15 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human IL-21 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human SCF 10 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human SCF 100 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human TNF-α 25 μg</li>
                                                    <li className='li-arrow'>MACS GMP Recombinant Human TPO 50 μg</li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>


                                <div className="divider my-2"></div>
                                <div className='row'>
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <div className="section-heading">
                                                    <p className='mb-0'><strong>CryoMACS </strong> - Freezings Bags - with overwrap EVA Bag</p><h5 className='mb-0 pb-0'></h5><p></p>
                                                </div>
                                                <div className="col-md-12">
                                                    <img src={CgmpProducts3} className="alignleft img-responsive" alt="" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="section-heading">
                                                    <p className='mb-0'><strong>DMSO</strong>  - 10 ml - GMP Grade </p><h5 className='mb-0 pb-0'></h5><p></p>
                                                </div>
                                                <div className="col-md-12">
                                                    <p>&nbsp;</p>
                                                    <p>&nbsp;</p>
                                                    <img src={CgmpProducts4} className="alignleft img-responsive" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default CgmpProducts;
